export {
  useSetting,
  useSettings,
  usePermission,
  type UseSettingResult,
  type UseSettingsResult,
  type UsePermissionResult,
  type PermissionKey,
  type PermissionStatus,
} from './hooks';
export {
  SETTING_KINDS,
  settingKind,
  type SettingKey,
  type SettingKind,
  type AccountSettingKey,
  type DeviceSettingKey,
} from './setting-kinds';
export {
  SETTINGS_REGISTRY,
  SECTION_ORDER,
  SECTION_TITLES,
  entriesForSection,
  type SettingSection,
  type SettingsEntry,
  type ControlEntry,
  type CustomEntry,
  type PermissionEntry,
  type SelectOption,
} from './registry';
export {
  isEntryVisible,
  isPlatformAllowed,
  isFlagEnabled,
  type PlatformOs,
  type FlagMap,
} from './gating';
export { SettingsRegistryView } from './components/settings-registry-view';
